import React from 'react'

import Loading from 'components/Loading'

export default function AuthLoading({ forceLoading = false }) {
  if (!forceLoading) {
    return null
  }

  return <Loading />
}
